<template>
  <v-container class="fill-height">
    <board-member-dashboard v-if="isBoardMember" />
    <default v-else />
  </v-container>
</template>

<script lang="ts">
import { mapActions } from 'vuex'
import Vue from 'vue'
import Default from '@/components/dashboard/Default.vue'
import BoardMemberDashboard from '@/components/dashboard/BoardMember.vue'
import { AccountType } from '@/API'
import { Company } from '@betterboards/shared/types/API'

export default Vue.extend({
  name: 'DashboardContainer',
  components: {
    Default,
    BoardMemberDashboard
  },
  computed: {
    selectedCompany (): Company {
      return this.$store.state.Company.selectedCompany
    },
    list (): Company[] {
      return this.$store.state.Company.list
    },
    currentRole (): string {
      return this.$store.state.Company.currentRole
    },
    isBoardMember (): boolean {
      return this.currentRole === AccountType.BoardMember
    }
  },
  methods: {
    ...mapActions('Company', ['selectCompany', 'clearSelectedCompany']),
    ...mapActions('User', ['roleByCompanyId'])
  }
})
</script>
